<div class="grid-6col input-grid-gaps p-2">
    <app-text-input
        [form]="form"
        id="title"
        class="w-full fr-6"
        [prefix]="prefix"
    ></app-text-input>
    <app-date-input
        [form]="form"
        id="dueDate"
        [prefix]="prefix"
        class="fr-2"
    ></app-date-input>

    <app-tags-input
        [form]="form"
        id="tags"
        class="fr-4"
        [prefix]="prefix"
        [suggestions]="store.data.getUserTaskUserTags() || []"
    ></app-tags-input>

    <app-input-user-multiselect
        [form]="form"
        class="fr-6"
        id="shareUserIds"
        [label]="prefix + 'fields.shareUserIds'"
    ></app-input-user-multiselect>

    <!--Terminy-->
    <app-card class="fr-3 appointments-wrapper">
        <ng-template #header>
            <div class="flex justify-content-between align-items-center gap-small small-buttons">
                <div class="textSubheader font-bold flex-1">
                    {{ prefix + 'fields.appointments' | translate }}
                </div>
                <app-button icon="pi-plus" size="small" (clickEvent)="editAppointment()"></app-button>
            </div>
        </ng-template>
        <ng-template #content>
            @let appointments = store.appointments();
            @if (appointments) {
                @if (appointments.length) {
                    @for (appointment of appointments; track $index) {
                        <div class="flex gap align-items-center">
                            <app-button
                                [icon]="appointment.completedAt ? 'pi-check-circle' : 'pi-circle'"
                                [text]="true"
                                [severity]="appointment.completedAt ? 'success' : 'secondary'"
                                (clickEvent)="toggleCompleteAppointment(appointment, $event)"
                            ></app-button>
                            <div class="flex flex-1 gap-small align-items-center">
                                <app-tag
                                    class="appointment-badge"
                                    [label]="appointment.date | localDate: 'dd.MM.yyyy HH:mm:ss'"
                                    [rounded]="true"
                                    (click)="editAppointment(appointment)"
                                ></app-tag>
                                @if (appointment.recurrenceRule) {
                                    <app-icon
                                        icon="pi-clock"
                                        [pTooltip]="appointment.recurrenceRule | formatRRule"
                                    ></app-icon>
                                }
                                @if (appointment.status) {
                                    <app-tag
                                        [severity]="appointment.status === UserTaskAppointmentStatus.INTIME ? 'success' : 'warn'"
                                        [label]="'userTasks.detail.appointment.statuses.' + appointment.status"
                                        [rounded]="true"
                                    ></app-tag>
                                }
                            </div>
                            <app-delete-button
                                [text]="true"
                                [hideLabel]="true"
                                confirmationType="none"
                                (clickEvent)="deleteAppointment(appointment, $event)"
                            ></app-delete-button>
                        </div>
                    }
                } @else {
                    <app-empty-state></app-empty-state>
                }
            } @else {
                <app-loading></app-loading>
            }
        </ng-template>
    </app-card>
    <app-file-upload-box
        class="fr-3"
        [multiple]="true"
        [existingFiles]="form.value.files"
    ></app-file-upload-box>

    <!--Zaznamy-->
    <app-card class="fr-6 entries-wrapper" [title]="prefix + 'fields.entries'">
        @let currentUser = store.globalGlobalStore.loggedUserStore.currentUser();
        <ng-template #content>
            <div class="flex-column flex-1 gap-small">
                @let entries = store.entries();
                @if (entries) {
                    @if (entries.length) {
                        <div id="entries-container" class="flex-column gap-small pr-2">
                            @for (entry of entries; track entry.id) {
                                <ng-container
                                    *ngTemplateOutlet="entryNode; context: { $implicit: entry, level: 0 }"
                                ></ng-container>
                            }
                        </div>
                    } @else {
                        <app-empty-state></app-empty-state>
                    }
                } @else {
                    <app-loading></app-loading>
                }
            </div>
        </ng-template>
        <ng-template #footer>
            <p-divider/>
            <ng-container
                *ngTemplateOutlet="newEntry; context: { $implicit: currentUser, item: newEntryItem, level: 0 }"
            ></ng-container>
        </ng-template>
    </app-card>
</div>

<ng-template #entryNode let-entry let-level="level">
    @if (!entry.isNew) {
        <div
            class="flex gap"
            [id]="'entry_' + (entry.parentId || 0) + '_' + entry.id"
            [style.padding-left.rem]="1.5 * level"
        >
            <app-avatar
                [initials]="entry.user | personInitials"
                [src]="entry.user.image"
            ></app-avatar>
            <div class="flex-column flex-1 gap-xxx-small">
                <div class="flex-column gap-x-small description">
                    <small>{{ entry.user | formatPerson }}</small>
                    @if (entry.isEdit) {
                        <div class="flex gap align-items-center pt-2">
                            <app-text-input
                                class="w-full"
                                [value]="entry.description"
                                (keyup.enter)="editEntryConfirm(entry)"
                                (selectedValueChange)="valChange($event, entry)"
                            ></app-text-input>
                            <app-button
                                icon="pi-save"
                                [disabled]="!entry.description"
                                (clickEvent)="editEntryConfirm(entry)"
                            ></app-button>
                        </div>
                    } @else {
                        <div>{{ entry.description }}</div>
                    }
                </div>
                <div class="flex gap-small align-items-center">
                    <div class="flex flex-1 gap-small">
                        @if (!entry.isEdit) {
                            <app-link-button
                                size='small'
                                [label]="prefix + 'actions.reply'"
                                (click)="replyEntry(entry)"
                            ></app-link-button>
                        }
                        @if (!entry.isEdit && entry.userId === store.globalGlobalStore.loggedUserStore.currentUserId()) {
                            <app-link-button
                                size='small'
                                [label]="prefix + 'actions.edit'"
                                (click)="editEntry(entry)"
                            ></app-link-button>
                            <app-link-button
                                size='small'
                                [label]="prefix + 'actions.delete'"
                                (click)="deleteEntry(entry, $event)"
                            ></app-link-button>
                        }
                    </div>
                    <small>{{ entry.updatedAt | localDate: 'dd.MM.yyyy HH:mm:ss' }}</small>
                    @if (entry.updatedAt !== entry.createdAt) {
                        <app-icon class="edited-info" icon="pi-pencil"></app-icon>
                    }
                </div>
            </div>
        </div>
    } @else {
        <ng-container
            *ngTemplateOutlet="newEntry; context: { $implicit: currentUser, item: entry, level: level }"
        ></ng-container>
    }

    @if (entry.children && entry.children.length > 0) {
        @for (child of $any(entry.children); track $index) {
            <ng-container *ngTemplateOutlet="entryNode; context: { $implicit: child, level: level + 1 }"></ng-container>
        }
    }
</ng-template>

<ng-template #newEntry let-currentUser let-item="item" let-level="level">
    <div
        class="flex gap align-items-center pt-2"
        [id]="'entry_'+ (item.parentId || 0) + '_0'"
        [style.padding-left.rem]="1.5 * level"
    >
        <app-avatar
            [initials]="currentUser | personInitials"
            [src]="currentUser.image"
        ></app-avatar>
        <app-text-input
            #newEntryInput
            class="w-full"
            [label]="prefix + 'fields.newEntry'"
            (keyup.enter)="addEntry(item, $event)"
            (selectedValueChange)="valChange($event, item)"
        ></app-text-input>
        <app-button
            icon="pi-send"
            [disabled]="!item.description"
            (clickEvent)="addEntry(item)"
        ></app-button>
    </div>
</ng-template>
